<div class="password-request h-100 d-flex align-items-center">
  <div class="col">
    <ng-container *ngIf="!emailSent; else sentEmail">
      <div class="form-login">
        <h1 class="mb-3" i18n="@@authentication_passwordRequest_title">
          Forgot your password ?
        </h1>
        <p
          class="text-light mb-5"
          i18n="@@authentication_passwordRequest_description"
        >
          Enter your email address to reset it
        </p>
        <form [formGroup]="passwordRequestForm" (ngSubmit)="onSubmit()">
          <div class="form-group">
            <label
              class="text-uppercase fw-medium"
              for="email"
              i18n="@@authentication_passwordRequest_formEmailLabel"
            >
              Email
            </label>
            <input
              class="form-control input-login"
              type="text"
              name="email"
              id="email"
              placeholder="name@example.com"
              formControlName="username"
              i18n-placeholder="
                @@authentication_passwordRequest_formEmailPlaceholder"
            />
          </div>

          <button
            type="submit"
            class="btn btn-primary mt-5 w-100 w-md-50 w-lg-75"
            [disabled]="!passwordRequestForm.valid"
          >
            <span i18n="@@authentication_passwordRequestSend">Envoyer</span>
            <span class="icon"
              ><img src="assets/icons/icon-white-arrow-right.svg" alt="arrow"
            /></span>
          </button>
        </form>
      </div>
    </ng-container>
    <ng-template #sentEmail>
      <div class="text-center text-primary fw-medium">
        <img
          src="assets/img/login-email-send.svg"
          alt="illustration"
          class="img-fluid mw-75"
        />
        <p class="mt-5" i18n="@@authentication_passwordRequestSuccess_message">
          A new link to reset your password has just been sent to you
        </p>
      </div>
    </ng-template>
  </div>
</div>
